function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg47(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 33.47 59.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M7.41,1.17C2.65,3.9,2.33,6.24,4.52,22.22c.54,3.94.18,5.82-2.11,10.93C-.1,38.73-.3,40.02.26,46.89c.77,9.41,1.42,11.77,3.42,12.54,2.63,1.01,4.17-1.69,4.86-8.5.91-9.08,7.47-21.99,9.53-18.75,1.46,2.29.88,7.32-1.53,13.35-3.36,8.42-3.79,10.83-2.27,12.9,1.79,2.45,3.62,1.27,8.46-5.49,5.69-7.94,7.13-12.96,6.48-22.54-.48-7.04-.23-8.7,2.13-14.45,3.11-7.58,2.83-11.94-.92-14.4-2.74-1.79-8.11-2.08-11.91-.63-1.62.62-2.74.62-3.13,0-.81-1.31-5.52-1.16-7.98.25",
    style: {
      fill: "#010101",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.41,3.1c9.44-.68,11.65-.52,12.54.88,1.5,2.37,1.11,6.4-1.18,12.38l-2.14,5.59h-9.39c-9.05,0-9.42-.09-10.32-2.46-1.85-4.87-2.35-12.43-.93-14.14,1.79-2.16,5.06-3.41,6.91-2.65.82.34,2.85.52,4.5.4",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.91,32.7c0,7.56-.33,9.11-3.09,14.28-3.36,6.3-7.91,11.4-7.91,8.86,0-.8,1.39-5.44,3.08-10.31,3.05-8.74,3.06-8.9,1.42-13.21-.92-2.4-1.98-4.37-2.36-4.37-4.2,0-11.4,13.66-11.97,22.74-.4,6.23-1.72,8.28-2.58,4.01-1.19-5.91-1.32-14.52-.25-17.3.64-1.68,2.03-5.3,3.09-8.05l1.91-5,9.34-.07,9.34-.07v8.48",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg47);
export default __webpack_public_path__ + "static/media/47.757affdb44d582d31985b170d133e109.svg";
export { ForwardRef as ReactComponent };